<footer class="footer">
  <!-- <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Design and Built by <a
        href="https://augustus.solutions" target="_blank">Augustus Solutions</a></span>
    <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted with <i
        class="ti-heart text-danger ml-1"></i></span>
  </div> -->
</footer>
